import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'antd';
import styled from '../../../../styled';
const UserMenuGroup = (_a) => {
    var { label, className, children } = _a, rest = __rest(_a, ["label", "className", "children"]);
    return (_jsxs("div", Object.assign({ className: className }, rest, { children: [_jsx(Typography, Object.assign({ className: 'hst-topbar-user-menu-group-label' }, { children: label })), children] })));
};
export default styled(UserMenuGroup, { label: 'hst-topbar-user-menu-group' }) `
  display: flex;
  flex-direction: column;

  & > .hst-topbar-user-menu-group-label {
    margin-top: 0.5rem;
    padding: 0.5rem 1rem 0.5rem 1rem;
    cursor: default;
    letter-spacing: 0.3px;
    font-weight: bold;
  }
`;
